export default "__VITE_ASSET__c1f1afbd__"